import React from "react"
import DOMPurify from "dompurify"

import { InfoItem } from "containers/Survey/types"

import styles from "./InfoList.module.scss"

export const InfoList: React.FC<{ items: InfoItem[] }> = ({
  items,
}): JSX.Element => (
  <ul className={styles.InfoList}>
    {items.map((item, index) => (
      <li key={index} className={styles.Item}>
        {item.imgUrl && (
          <img className={styles.Picto} src={item.imgUrl} alt="" />
        )}
        <span
          className={styles.Text}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.text) }}
        />
      </li>
    ))}
  </ul>
)
